module.exports = __webpack_public_path__ + "img/btninmodal-m-big.78babe0c.svg";